// removed by extract-text-webpack-plugin
module.exports = {"ad-img-bckgrnd":"ad-img-bckgrnd___313Zr center___2iqBf","ad-cntr":"ad-cntr___3vJIc center___2iqBf space-top-12___3DU92 space-bottom-12___rGCm0","ad-icn":"ad-icn___boV8Q","ad-cpy":"ad-cpy___2uVCP","ad-hl":"ad-hl___2QfjF h2___hzLuT","ad-p":"ad-p___3wq7x space-top-2___3NWCg h5___l1yk7","wht":"wht___138dz"};


//////////////////
// WEBPACK FOOTER
// ./src/core/AppDisclaimer/AppDisclaimer.css
// module id = 901
// module chunks = 0